// tslint:disable-next-line: max-line-length
import { Injectable, Injector } from '@angular/core';
import { DwCoreConfig, DwAuthGuardService, DwConfig, DwUIMetaDataConfigDefaults, DwConfigServiceToken, DwUIConfig, DwAgGridComponent, DwUIMetaDataConfig, DwConfigProviderBase, DwUiConfigName, DwCoreConfigDefaults, DwAttributeType, DwControlType, DwMediaConfigName, DwMediaConfig, DwFormDebugService, DwLogSeverity, DwSecurityState, DwUserInactivityConfig, DevwareMetaDataService, DwEnvironmentInfo, DwUiConfigInitDecorator, DwUiConfigRegistryService, DwUiRegistryType, DwUiContainerStyleReference, DwContainerCollapseStyle, DwFilterTileLoadMode } from '@devwareapps/devware-cap';
import { environment } from 'src/environments/environment';
import { angularApplicationVersion } from './app-version';
import { AppPermissions } from './meta-data/app-permissions.enum';
import { AdminManagerService } from './features/shared/services/admin-manager.service';
import { PilexosUserTypeIds } from './features/shared/models/pilexos-user-type.enum';
import { EventManagementService } from './features/shared/services/event-management.service';
import { AppMetaDataItemNames, FlightSchoolTypeAllItems, UserTypeAllItems } from './meta-data/app-meta-data.service';
import { EnvironmentConfigItem } from '../environments/models/environment-config.model';
import { EnvironmentNames } from '../environments/models/environment-names.enum';
import { Router } from '@angular/router';
import { SchoolRepositoryService } from './features/schools/services/school-repository.service';
import { map } from 'rxjs/operators';
@DwConfig()
@Injectable()
export class AppDevwareConfigProviderService extends DwConfigProviderBase {
    private static readonly enhancedDefaultContainerStyle: DwUiContainerStyleReference = {
        keyName: '',
        display: 'Default',
        containerClass: 'dw-form-section-container-enhanced',
        containerInnerClass: 'dw-form-section-container-enhanced-inner',
        containerTitleClass: 'dw-form-section-container-enhanced-header'
    };

    environmentConfigItem: EnvironmentConfigItem;
    constructor(private eventManagementService: EventManagementService,
        private injector: Injector,
        private router: Router,
        private uiConfigRegistryService: DwUiConfigRegistryService
        // private adminManagerService: AdminManagerService,
    ) {
        super();
        // this.setupRegistrations();

        this.setupReplicatedEvents();
    }

    setupReplicatedEvents() {
        this.eventManagementService.addEventReplicator({
            itemName: AppMetaDataItemNames.CheckRideRequest,
            replicateItemNames: [AppMetaDataItemNames.FlightSchoolApplicant]
        });

        const devwareMetaData = new DevwareMetaDataService();

        this.eventManagementService.addEventReplicator({
            itemName: devwareMetaData.DwDataImport.ItemDetail.ItemName,
            replicateItemNames: [AppMetaDataItemNames.AcsCode, AppMetaDataItemNames.QuestionBank]
        });
        // this.eventManagementService.addEventReplicator({
        //     itemName: AppMetaDataItemNames.ScheduleBlockItem,
        //     replicateItemNames: [AppMetaDataItemNames.ScheduleBlock]
        // });
    }

    configureCoreConfig(dwCoreConfig: DwCoreConfig) {

        dwCoreConfig.applicationVersion = angularApplicationVersion;
        // Set Core configuration values
        dwCoreConfig.baseTitle = AppDevwareConfigProviderService.getEnvironmentBaseTitle();

        this.environmentConfigItem = AppDevwareConfigProviderService.getEnvironmentConfigItem();
        if (!this.environmentConfigItem) {
            console.error('No environment config item found');
            return;
        }

        dwCoreConfig.apiRoot = this.environmentConfigItem.apiRoot;
        
        dwCoreConfig.applicationVersion = angularApplicationVersion;


        //dwCoreConfig.apiRoot = environment.apiRoot;
        dwCoreConfig.alternateApiRoots = (environment as any).alternateApiRoots as any;
        dwCoreConfig.tenantKey = (environment as any).tenantKey;

        if (environment.environmentMessage == 'Dev') {
            DwFormDebugService.showAllMessages = false;
            DwFormDebugService.componentNameList = ['Training', 'DwContextConfigurationBase', 'DwMetadataFormBuilderService'];
            DwFormDebugService.componentNameList = [];
            DwFormDebugService.disableLogging = true;
        }

        // configure logging
        dwCoreConfig.enableConsoleLogging = (environment as any).enabledConsoleLogging;
        dwCoreConfig.loggingConfig.writeAllToConsole = (environment as any).enableConsoleLogging;

        dwCoreConfig.loggingConfig.serverMessagePrefix = 'Pilexos Angular';
        dwCoreConfig.loggingConfig.writeToServerLevels = [DwLogSeverity.error];


        dwCoreConfig.loggingConfig.logSlowApiCalls.elapsedTimeThresholdMs = 30000;

        // Override the default CanActivate guard
        dwCoreConfig.routingConfig.defaultCanActivateGuards = [DwAuthGuardService];
        dwCoreConfig.routingConfig.googleAnalyticsTrackingToken = environment.googleAnalyticsTrackingToken;

        // Setup security anomymous access
        dwCoreConfig.securityConfig.allowAnonymousAccess = true;
        dwCoreConfig.securityConfig.securityTokenTimeoutMinutes = 5;

        dwCoreConfig.securityConfig.autoLoginAfterRegistration = true;

        dwCoreConfig.routingConfig.defaultRouteUrl = '';;

        dwCoreConfig.autoUpdateConfig.updateMessageTooltip = 'Refresh your browser to get the latest version of the app';

        //dwCoreConfig.autoUpdateConfig.updateMessage = 30;

        if (!environment.disabledUserInactvityTimeout) {
            dwCoreConfig.securityConfig.userInactivitiy = {
                warningTimeoutMinutes: 25,
                warningMessage: 'You will be logged out in 5 minutes due to inactivity.',
                logoutTimeoutMinutes: 30,
                logoutMessage: 'You have been logged out due to inactivity.',
            };

            dwCoreConfig.securityConfig.userInactivtyFunc = (securityState: DwSecurityState) => this.getUserInactivityConfig(securityState);
        }
    }

    getUserInactivityConfig(securityState: DwSecurityState): DwUserInactivityConfig {
        if (this.onPOAOrCheckrideRoute()) {
            const userInactivitiy: DwUserInactivityConfig = {
                warningTimeoutMinutes: 115,
                warningMessage: 'You will be logged out in 5 minutes due to inactivity.',
                logoutTimeoutMinutes: 120,
                logoutMessage: 'You have been logged out due to inactivity.',
                securityAuditMessage: "Checkride/POA inactivity logout."
            };

            return userInactivitiy;
        }

        return null;
    }

    onPOAOrCheckrideRoute() {
        const url = this.router.url;

        const urlsToCheck = [
            "/plan-of-action/plans/",
            "/checkrides/",
            "school-checkries/",
            "/bookings/"
        ];

        for (const checkUrl of urlsToCheck) {
            if (url.includes(checkUrl)) {
                return true;
            }
        }

        return false;
    }

    configureAdditionalConfig(configName: string, config: any, dwCoreConfig: DwCoreConfig) {
        switch (configName) {
            case DwUiConfigName:
                this.configureUIConfig(config, dwCoreConfig);
                break;

            case DwUIMetaDataConfigDefaults.configName:
                this.configureUIMetaDataConfig(config);
                break;

            case DwMediaConfigName:
                this.configureMediaConfig(config, dwCoreConfig);
        }
    }


    private configureUIConfig(dwUiConfig: DwUIConfig, dwCoreConfig: DwCoreConfig) {
        // Setup Contact us menu
        dwUiConfig.showContactUs = environment.showContactUs;
        dwUiConfig.contactUsEMail = environment.contactUsEmail;

        dwUiConfig.gridComponent = DwAgGridComponent;
        dwUiConfig.pageFooterHeight = 0;
        dwUiConfig.showFooter = false;

        dwUiConfig.allowConfiguration = environment.allowConfiguration;

        dwCoreConfig.globals.apiRoot = dwCoreConfig.apiRoot;
        dwCoreConfig.globals.defaultAvatar = dwUiConfig.defaultAvatarImageUrl;

        dwUiConfig.defaultBackgroundImageUrl = 'assets/pilexos/default_banner.png';
        dwUiConfig.emailValidationRegEx = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,50})+$/;

        // Customize the registration process
        dwUiConfig.registrationConfig = {
            registerTitle: 'Sign up for an account',
            registerButtonText: 'Sign up',
            registrationComponentKey: 'pilexos-user-registration-extension',
            useFloatLabelOnRegistration: true,
            useFloatLabelOnLogin: true,
            registrationHideUserName: true,
            ...dwUiConfig.registrationConfig
        };

        // Setup custom colors

        dwUiConfig.styleConfig.standardColors = [
            ...dwUiConfig.styleConfig.standardColors,
            {
                name: 'Pilexos Burgundy',
                display: 'Pilexos Burgundy',
                foregroundClass: 'pilexos-burgandy',
                backgroundClass: 'pilexos-burgandy-bg',
                foregroundColor: '#800000',
                backgroundColor: 'white',
            }
        ]

        dwUiConfig.enableThemes = true;

        dwUiConfig.securityInfoConfig = {
            showWelcome: false,
            getNameDisplay: (user, emulating, config, nameOnly) => {
                if (!user) {
                    return '';
                }

                let currentUserDisplay = user.FirstNameLastName;

                if (!nameOnly) {
                    if (config.showWelcome) {
                        return 'Welcome ' + currentUserDisplay;
                    }
                    if (emulating) {
                        currentUserDisplay = user.FirstNameLastName;
                        return 'Emulating ' + currentUserDisplay;

                    }
                }

                return currentUserDisplay;
            },
            getAdditionalLine: (user, emulating, config) => {
                const adminManagerService = this.injector.get(AdminManagerService);
                const schoolRepositoryService = this.injector.get(SchoolRepositoryService);

                const aviatorUser = adminManagerService.getPilexosUser(user);

                switch (aviatorUser?.UserTypeId) {
                    case PilexosUserTypeIds.flightSchool:
                        return 'Flight School';
                    case PilexosUserTypeIds.studentApplicant:
                        return 'Student';
                    case PilexosUserTypeIds.pilotExaminer:
                        return 'Examiner';
                    case PilexosUserTypeIds.flightInstructor:
                        return 'Instructor';
                    case PilexosUserTypeIds.checkInstructor:
                        return schoolRepositoryService.getSchoolFeatures()
                            .pipe(map(features => {
                                switch(features?.FlightSchoolTypeId) {
                                    case FlightSchoolTypeAllItems.ODA:
                                        return 'Unit Member';          
                                    case FlightSchoolTypeAllItems.Standard:
                                    default:
                                        return 'Check Instructor';       
                                }
                            }));
                    default:
                        return 'Admin'
                }
            }
        }

    }

    private configureUIMetaDataConfig(dwUiMetaDataConfig: DwUIMetaDataConfig) {
        // Default date/time configuration
        dwUiMetaDataConfig.useGmtDateTime = true;
        dwUiMetaDataConfig.use24HourTime = false;
        dwUiMetaDataConfig.pdfRenderWaitTimeMs = 1200;
        dwUiMetaDataConfig.emailValidationRegEx = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,50})+$/;;
        dwUiMetaDataConfig.defaultContainerStyle = {
            ...AppDevwareConfigProviderService.enhancedDefaultContainerStyle
        };
        dwUiMetaDataConfig.defaultContainerCollapseStyle = DwContainerCollapseStyle.chevronRight;
        dwUiMetaDataConfig.filterTileLoadMode = DwFilterTileLoadMode.batchApi;

        dwUiMetaDataConfig.gridDefaultPreferences.rowHeight = 25;

        dwUiMetaDataConfig.userContextExtendedAttributes = [
            { name: 'UserTypeId', display: 'User Type', attrType: DwAttributeType.Integer, controlType: DwControlType.DropDownList, lookupId: 301 }
        ];

        dwUiMetaDataConfig.formAdvancedSettings = {
            variableContext: {
                formUpdateDelayMs: -1,
                mergeFullContext: true,
                contextUpdateDelayMs: -1,
                contextUpdateMergeFullContext: true,
                logContextChanges: true
            }
        }

    }

    @DwUiConfigInitDecorator({
        name: 'PilexosUiConfigInit',
        useDI: true
    })
    setupRegistrations() {
        // CAP currently registers the unnamed default independently of
        // defaultContainerStyle, so replace that registry entry for Pilexos.
        this.uiConfigRegistryService.registerItem(
            DwUiRegistryType.containerStyles,
            { ...AppDevwareConfigProviderService.enhancedDefaultContainerStyle }
        );
    }

    configureMediaConfig(config: DwMediaConfig, dwCoreConfig: DwCoreConfig) {
        config.defaultMaxFileSizeMb = 50;
        
        config.cdnSettings = {
            useCDN: this.environmentConfigItem.useCDN && !!this.environmentConfigItem?.cdnRoot,
            cdnUrl: this.environmentConfigItem?.cdnRoot,
        }
    }

    public static getEnvironmentConfigItem(): EnvironmentConfigItem {
        const mainEnvironment = environment.environment;
        const configuredAltEnvironment = (environment as any).altEnvironment as EnvironmentConfigItem | EnvironmentConfigItem[];

        if (!configuredAltEnvironment) {
            return mainEnvironment;
        }

        const altEnvironments = Array.isArray(configuredAltEnvironment)
            ? configuredAltEnvironment
            : [configuredAltEnvironment];
        const hostName = window.location.hostname.toLowerCase();
        const matchingEnvironment = altEnvironments.find(altEnvironment =>
            !!altEnvironment.hostNameMatch
            && altEnvironment.hostNameMatch.toLowerCase() === hostName
        );

        if (matchingEnvironment) {
            return matchingEnvironment;
        }

        return mainEnvironment;
    }

    public static getEnvironmentMessage(): string {
        const environmentConfigItem = AppDevwareConfigProviderService.getEnvironmentConfigItem();

        if (environmentConfigItem !== environment.environment) {
            return environmentConfigItem?.envMessage;
        }

        return environment.environmentMessage || environmentConfigItem?.envMessage;
    }

    public static getEnvironmentBaseTitle(): string {
        return AppDevwareConfigProviderService.getEnvironmentBaseTitleForRuntime();
    }

    public static getEnvironmentBaseTitleForRuntime(environmentInfo?: DwEnvironmentInfo): string {
        const appTitle = ((environment as any).appTitle || '').trim();
        const environmentConfigItem = AppDevwareConfigProviderService.getEnvironmentConfigItem();

        if (!environmentConfigItem || environmentConfigItem.envKey === EnvironmentNames.prod) {
            return appTitle;
        }

        if (AppDevwareConfigProviderService.isLocalEnvironment(environmentConfigItem)) {
            return AppDevwareConfigProviderService.getLocalEnvironmentBaseTitle(appTitle, environmentConfigItem, environmentInfo);
        }

        return AppDevwareConfigProviderService.buildEnvironmentTitle(
            appTitle,
            environmentConfigItem.environmentEmoji,
            environmentConfigItem.environmentLabel
        );
    }

    private static getLocalEnvironmentBaseTitle(appTitle: string, environmentConfigItem: EnvironmentConfigItem, environmentInfo?: DwEnvironmentInfo): string {
        const runtimeEnvironment = AppDevwareConfigProviderService.getRuntimeEnvironmentDisplayInfo(environmentInfo, environmentConfigItem);

        if (!runtimeEnvironment) {
            return AppDevwareConfigProviderService.buildEnvironmentTitle(
                appTitle,
                environmentConfigItem.environmentEmoji,
                environmentConfigItem.environmentLabel
            );
        }

        if (runtimeEnvironment.label === 'LOCAL') {
            return AppDevwareConfigProviderService.buildEnvironmentTitle(
                appTitle,
                environmentConfigItem.environmentEmoji,
                'LOCAL UI/API',
                '◆◆'
            );
        }

        return AppDevwareConfigProviderService.buildEnvironmentTitle(
            appTitle,
            runtimeEnvironment.emoji,
            `LOCAL -> ${runtimeEnvironment.label}`,
            '✦'
        );
    }

    private static buildEnvironmentTitle(appTitle: string, environmentEmoji?: string, environmentLabel?: string, separatorSymbol?: string): string {
        return [(environmentEmoji || '').trim(), (separatorSymbol || '').trim(), appTitle, environmentLabel ? `[${environmentLabel.trim()}]` : '']
            .filter(x => !!x)
            .join(' ')
            .trim();
    }

    private static isLocalEnvironment(environmentConfigItem: EnvironmentConfigItem): boolean {
        return environmentConfigItem?.envKey === EnvironmentNames.testlocal
            || environmentConfigItem?.envKey === EnvironmentNames.enterprise
            || AppDevwareConfigProviderService.isLocalApiRoot(environmentConfigItem?.apiRoot);
    }

    private static isLocalApiRoot(apiRoot: string): boolean {
        return !!apiRoot && /localhost|127\.0\.0\.1/i.test(apiRoot);
    }

    private static getRuntimeEnvironmentDisplayInfo(environmentInfo?: DwEnvironmentInfo, environmentConfigItem?: EnvironmentConfigItem): { label: string, emoji: string } {
        const environmentName = `${environmentInfo?.EnvironmentName || ''}`.trim().toLowerCase();

        if (environmentName.includes('local')) {
            return { label: 'LOCAL', emoji: '🟢' };
        }

        if (environmentName.includes('stage')) {
            return { label: 'STAGE', emoji: '🟡' };
        }

        if (environmentName.includes('test')) {
            return { label: 'TEST', emoji: '🟠' };
        }

        if (environmentName.includes('feature') || environmentName.includes('dev')) {
            return { label: 'DEV', emoji: '🔵' };
        }

        if ((environmentInfo as any)?.IsProd) {
            return { label: 'PROD', emoji: '' };
        }

        if ((environmentInfo as any)?.IsTest) {
            return { label: 'TEST', emoji: '🟠' };
        }

        if ((environmentInfo as any)?.IsDev) {
            return { label: 'DEV', emoji: '🔵' };
        }

        if (AppDevwareConfigProviderService.isLocalApiRoot(environmentConfigItem?.apiRoot)) {
            return { label: 'LOCAL', emoji: '🟢' };
        }

        return null;
    }
}


